export default {
  permissions: store => store.permissions || [],
};
